import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback
} from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../store/loaderSlice";
import Bootstrap4DatePickerComponent from "../../client/components/Bootstrap4DatePickerComponent";

import JSZip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";

import { isMobile } from "react-device-detect";

import DatePickerComponent from "../../client/components/DatePickerComponent";

import "datatables.net-buttons-dt/css/buttons.dataTables.min.css"; // Buttons extension styling
import "./TableComponent.css"; // Import your CSS file

export default function PlDownlineDesktopPopup() {
  const { userId } = useParams();
  const dispatch = useDispatch();

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);
  const [isLoading, setIsLoading] = useState(true);

  const [statement, setStatement] = useState([]);
  const [uniqueGridKey, setUniqueGridKey] = useState(Date.now());
  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = true;
  const [dataUserName, setDataUserName] = useState("");

  const [pageSize, setPageSize] = useState(100);

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const showCreditCashTxt = (payment_type) => {
    let returnTxt = "";
    if (payment_type == 1) {
      returnTxt = "(Credit)";
    } else if (payment_type == 2) {
      returnTxt = "(Cash)";
    }
    return returnTxt;
  };

  const cols = useMemo(
    () => [
      {
        title: "#",
        data: null,
        orderable: false,
        responsivePriority: 1,
        render: (data, type, row, meta) => `
          <div class="d-flex align-items-center gap-2">
          <button type="button" class="toggle-row toggle-closed">+</button>
            <span class="seq-number"  style="padding-left:10px">${
              meta.row + 1
            }</span>
            
          </div>
        `
      },
      {
        title: "Date",
        data: "created_date",
        className: "dt-right",
        // After Description so on narrow screens # + Date + Description stay visible; Amount/Balance move to expanded details
        responsivePriority: 2,
        render: (d, type) => {
          if (type === "display" || type === "filter") {
            if (!d) return "";
            const dt = new Date(d);
            const datePart = dt.toLocaleDateString(undefined, {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            });
            const fullTime = dt.toLocaleTimeString(undefined, {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
            // Split "04:47 pm" into time "04:47" and meridiem "pm"
            const meridiemMatch = fullTime.match(/^([\d:]+)\s*(am|pm)$/i);
            if (meridiemMatch) {
              const hhmm = meridiemMatch[1];
              const meridiem = meridiemMatch[2];
              return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem">${hhmm}</span> <span class="date-meridiem" style="font-size:1rem">${meridiem}</span></span></span>`;
            }
            return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem">${fullTime}</span></span></span>`;
          }
          return d ? new Date(d).getTime() : 0;
        }
      },
      {
        title: "Description",
        data: "remark",
        render: (data, type, row, meta) =>
          data === "Opening Balance"
            ? `<span style='color:#04b181;font-weight:semibold;font-size:1rem;font-weight:400' style="white-space: break-spaces;" class="site_family">${data}</span>`
            : `<a  href="#" style="white-space: break-spaces;font-size:1rem;font-weight:400" onClick="showBetDetails('${
                row.id
              }',${row.game_type},${row.type}, ${
                row.user_role
              })" class='text-success site_family'>${
                row.remark
              } ${showCreditCashTxt(row.payment_type)}</a>`,
        responsivePriority: 3
      },
      {
        title: "Amount",
        data: "amount",
        render: (d) =>
          `<span class="site_family" style="font-size:1rem;font-weight:400">${"&nbsp;&nbsp;&nbsp;"} ${formatTruncate(
            d
          )}</span>`,
        responsivePriority: 4
      },

      {
        title: "Balance",
        data: "after_balance",
        render: (d) =>
          `<span class="site_family" style="font-size:1rem;font-weight:400">${"&nbsp;&nbsp;&nbsp;"}${formatTruncate(
            d
          )}</span>`,
        responsivePriority: 5
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "record_id",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "game_type",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "user_role",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 6
      },

      {
        title: "",
        data: "payment_type",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "type",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 4
      }
    ],
    []
  );

  const showDescription = (data, row) => {
    let marketTypeTxt = "";
    if (row.market_type == 2) {
      marketTypeTxt = "/Bookmaker";
    } else if (row.market_type == 1) {
      marketTypeTxt = "/Match Odd";
    } else if (row.market_type == 5) {
      marketTypeTxt = "/Tie";
    } else if (row.market_type == 6) {
      marketTypeTxt = "/Figure";
    } else if (row.market_type == 8) {
      marketTypeTxt = "/EvenOdd";
    } else if (row.market_type == 3) {
      marketTypeTxt = "/Fancy";
    }

    if (data === "Opening Balance") {
      return `<span style='color:#04b181;font-weight:semibold;'  className="site_family">${data}</span>`;
    }

    const resultTxt = row.result ? ` [${row.result}]` : "";
    //const label = `${row.remark}`;
    const label = `${row.description}${marketTypeTxt}${resultTxt}`;

    if (Number(row.voided) === 1) {
      return `<a href="#" onClick="showBetDetails('${row.id}',${row.game_type},${row.market_type})" class="text-muted ledger-row-voided site_family">
      ${label} (VOID)</a>`;
    }

    return `<a href="#" onClick="showBetDetails('${row.id}',${row.game_type},${row.market_type})" class="text-success site_family">
      ${label}</a>`;
  };

  useEffect(() => {
    window.showBetDetails = (id, game_type, type, user_role) => {
      //openLedgerPopUp(id, game_type);
      if (type == 3) {
        openCreditDebitDetailsPopUp(id);
      } else {
        if (user_role == 8) {
          openLedgerPopUp(id, game_type);
        } else {
          openPopUp(id);
        }
      }
    };

    return () => {
      // clean up when react component unmounts. It will clean it from the memory when we will navigate to other component or page.
      delete window.showBetDetails;
    };
  }, []);

  const openCreditDebitDetailsPopUp = async (id) => {
    const popup = window.open(
      "/credit-debit-popup-details/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const openLedgerPopUp = async (id, game_type) => {
    if (game_type == 9) {
      const popup = window.open(
        "/client-virtual-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 6) {
      const popup = window.open(
        "/client-casino-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 7 || game_type == 10) {
      const popup = window.open(
        "/client-tp-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else {
      const popup = window.open(
        "/clinet-bet-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    }
  };

  const openPopUp = async (id) => {
    const popup = window.open(
      "/plby-hierarchical/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !statement.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Ensure first column (seq/#) is not orderable and has a consistent renderer
    if (normalizedCols[0]) {
      normalizedCols[0].orderable = false;
      // Ensure seq column has a render that places a span.seq-number we can update later
      const originalRender = normalizedCols[0].render;
      normalizedCols[0].render = function (data, type, row, meta) {
        // For ordering/searching we should return numeric value; for display return HTML
        if (type === "display" || type === "filter") {
          const seqHTML = `<div class="seq-cell d-flex align-items-center gap-1">
            <span class="seq-number">${
              typeof data === "number" ? data : ""
            }</span>
            <button type="button" class="toggle-row toggle-closed" style="display:none;">+</button>
          </div>`;
          // If user provided an original render, respect it for display of the number placeholder
          return originalRender
            ? originalRender(data, type, row, meta)
            : seqHTML;
        }
        // For other types (order/search) return a stable numeric value if available
        return typeof data === "number" ? data : 0;
      };
    }

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe statement (only include referenced keys + seq)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (statement || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        destroy: true,
        buttons: ["print", "excel", "pdf"],
        columns: normalizedCols,

        responsive: { details: false },
        pageLength: pageSize || 100,
        lengthChange: true,
        autoWidth: false,
        ordering: true,
        order: initialOrder,
        columnDefs: [{ targets: 0, orderable: false }], // safeguard
        dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',
        dom: "Bfrtip", // 👈 IMPORTANT (shows buttons)
        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: function (row, data, index) {
          // Mobile breakpoint (same as your CSS media query)
          const isMobile = window.matchMedia("(max-width:640px)").matches;

          if (isMobile) {
            // single dark color for every main row on mobile
            $(row).css({
              "background-color": "#f2f2f2", // dark row background
              color: "" // light text
            });
          } else {
            // Desktop: keep zebra striping you had previously
            $(row).css({
              "background-color": index % 2 === 0 ? "#f2f2f2" : "#ffffff",
              color: "" // let default text color apply
            });
          }
        }
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        console.log("i:", i);
        const col = dt.column(i);
        console.log("col:", col);
        console.log("Row Data:", rowData);
        console.log("Normalized Cols:", normalizedCols);
        if (!col || !col.header()) return;

        const title = $(col.header()).text();
        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        // Using the same render() as parent column
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        console.log("rendered:", rendered);

        html += `
      <tr>
        <td style="width:40%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #eee;">
          <span style="font-weight:bold;">${title}</span> 
          ${rendered}
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(`<table class="table table-sm mb-0">${details}</table>`)
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // --------- Core: renumber seq column on order/search/draw ----------
    const renumberSeq = () => {
      // rows in current ordering (includes all rows, not just current page)
      const nodes = dt.rows({ order: "applied" }).nodes();
      $(nodes).each((index, rowNode) => {
        // update the first cell's .seq-number text
        const $firstCell = $(rowNode).find("td").eq(0);
        const $span = $firstCell.find(".seq-number");
        if ($span.length) {
          $span.text(index + 1);
        } else {
          // fallback: if render didn't produce span, set plain text
          $firstCell.text(index + 1);
        }
      });
    };

    // call renumberSeq after draw/order/search
    dt.on("order.dt search.dt draw.dt", () => {
      try {
        renumberSeq();
        updateToggleButtons();
      } catch (e) {
        // swallow safe errors
        console.warn("Renumber/Toggle update failed:", e);
      }
    });

    // Initial numbering (after initial draw)
    requestAnimationFrame(() => {
      renumberSeq();
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, statement, pageSize, defaultExpand, isLoading]);

  let username = "";
  let sponsor = "";

  const getHistory = useCallback(async () => {
    console.log("Trying to fetch account statement");
    dispatch(setLoader(true));
    if (loadingRef.current) return;

    let from = toLocalString(startDate);
    let til = toLocalString(endDate);

    try {
      let obj = {};
      obj.userId = userId;
      obj.startDate = from;
      obj.endDate = til;

      const response = await axiosInstance.post("/company/pl-Downline", obj);
      setTimeout(() => {
        setStatement(response.data.recordList || []);
        setUniqueGridKey(Date.now());
        setIsLoading(false);
        dispatch(setLoader(false));
        setDataUserName(response?.data?.username);
        loadingRef.current = false;
      }, 100);
    } catch (error) {
      console.error("Error fetching account statement:", error);
      await dispatch(setLoader(false));
      setIsLoading(false);
      loadingRef.current = false;
      //setStatement([]);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    getHistory();
  }, []);

  function toLocalString(d) {
    const pad = (x) => String(x).padStart(2, "0");
    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    );
  }
  return (
    <div className="container-fluid" style={{ padding: "0px 5px 0px 5px" }}>
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <i className="fa fa-align-justify site_family"></i> Report
                Filter
              </div>
              <div className="card-body">
                <form
                  id="ReportFilterForm"
                  className="form-inline"
                  method="get"
                  style={{ padding: "7px" }}
                >
                  <div className="row" style={{ textAlignLast: "justify" }}>
                    <div className="col-12 col-md-5">
                      {/*<DatePickerComponent
                        defaultDate={startDate}
                        setSelectedDate={startDateSet}
  />*/}

                      <Bootstrap4DatePickerComponent
                        pickerId="ReportFrom"
                        inputId="DisplayFrom"
                        defaultDate={startDate}
                        setSelectedDate={startDateSet}
                      />
                    </div>
                    <strong style={{ margin: "auto" }}>&nbsp;-&nbsp;</strong>
                    <div className="col-12 col-md-5">
                      <Bootstrap4DatePickerComponent
                        pickerId="ReportTo"
                        inputId="DisplayTo"
                        defaultDate={endDate}
                        setSelectedDate={endDateSet}
                      />

                      {/*<DatePickerComponent
                        defaultDate={endDate}
                        setSelectedDate={endDateSet}
/>*/}
                    </div>
                    <div
                      className="form-group editsbmtbtn"
                      style={{
                        marginTop: "10px",
                        marginRight: "11px",
                        width: isMobile ? "100%" : "auto"
                      }}
                    >
                      <button
                        className="btn btn-success site_family"
                        onClick={() => getHistory()}
                        style={{ background: "#02b181", float: "right" }}
                        type="button"
                      >
                        <strong>Submit</strong>
                      </button>
                    </div>
                  </div>
                  <div className="row col-12"></div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header site_family">
                <strong className="site_family"> {dataUserName}</strong> -
                Account Ledger
              </div>
              <div className="card-body">
                <div
                  id="tableLedger_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="dataTables_wrapper no-footer">
                        <div className="row">
                          <div className="col-sm-12">
                            <div>
                              {isLoading ? (
                                <div className="text-center mt-4 mb-4">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                  <p className="text-muted mt-2 site_family">
                                    Loading account statement...
                                  </p>
                                </div>
                              ) : statement.length === 0 ? (
                                <p className="text-center mt-3 text-muted site_family">
                                  No records found for the selected period.
                                </p>
                              ) : (
                                <div
                                  className="table-responsive p-1"
                                  key={uniqueGridKey}
                                >
                                  <table
                                    ref={gridTableRef}
                                    className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2"
                                    style={{ width: "100%" }}
                                  >
                                    <thead className="site_family">
                                      <tr>
                                        {cols.map((c) => (
                                          <th
                                            key={c.data || c.title}
                                            className="site_family"
                                          >
                                            {c.title}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody />
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
  .table { width: 100% !important; }
  .table.table-striped td, .table.table-striped th {
    padding: 6px 8px !important;
    font-size:17px;
    white-space: nowrap;
    vertical-align: middle;
  }
  table.table-sm td { padding: 4px 6px !important; }
  tr.shown + tr > td { background-color: #fafafa; }
  .seq-cell { display:flex; align-items:center; gap:6px; }
  .toggle-row {
    border: none;
    outline: none;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    line-height: 1;
  }
  .toggle-closed { background-color: #28a745; }
  .toggle-open { background-color: #dc3545; }
  .toggle-row:active { transform: scale(0.94); }
  .dt-info { float:none !important; text-align:center !important; }
  .dt-paging-button { margin-left:0 !important; padding: 0 !important; }
  .dt-paging { text-align:center !important; }
  .pagination { display:block !important; }

  .table-striped tbody tr:nth-of-type(odd) { background-color: transparent; }
  .table tr:nth-child(even) { background-color: transparent; }

  table.dataTable.order-column tbody tr > .sorting_1,
  table.dataTable.order-column tbody tr > .sorting_2,
  table.dataTable.order-column tbody tr > .sorting_3,
  table.dataTable.display tbody tr > .sorting_1,
  table.dataTable.display tbody tr > .sorting_2,
  table.dataTable.display tbody tr > .sorting_3 {
    background-color: transparent;
  }

  .toggle-row { width:15px; height:15px; margin-left:2px; }

  .dt-search { float:right; padding-right:10px; }
  .dt-search .form-control{
    border: 1px solid #000;
    margin-bottom:5px;
  }

  .actionBtn {
    position: absolute;
    width: 100%;
    margin-top: 20px;
    z-index: 10;
  }

  /* MOBILE ONLY FIXES */
  @media screen and (max-width: 640px) {

    .actionBtn {
      width: 100%;
      margin-top: 20px;
      position: relative;
    }

    .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }

    .dataTable {
      margin-top:10px !important;
    }

    .table-responsive {
      margin-top:0px !important;
    }

    .dt-buttons {
      margin: 0 auto !important;
      float: none !important;
      width: auto !important;
      display: flex !important;
      justify-content: center;
    }
      
  }
        .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }
      @media screen and (max-width: 640px) {
  /* Make the top area stack nicely */
  .top.d-flex {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  /* Center the search container */
  .dt-search {
    display: flex !important;
    justify-content: center !important; /* center horizontally */
    width: 100% !important;
    margin: 8px 0 !important;
    padding: 0 12px;
    box-sizing: border-box;
  }

  /* Ensure the label + input stay inline and centered */
  .dt-search .dataTables_filter,
  .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    justify-content: center;
    width: auto !important;
    margin: 0;
  }

  /* Limit input width so it doesn't push other controls */
  .dt-search input[type="search"],
  .dataTables_filter input[type="search"] {
    width: 160px !important;
    max-width: 80% !important;
    display: inline-block !important;
    margin: 0 !important;
  }
    .dt-container {
      margin-top:0px !important;
    }
    }
    .dataTable {
    margin-top:15px;
    }
`}</style>
    </div>
  );
}
